// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3657":"98ad3d31484edf8a","3699":"252b62fa87ff69b8"}[chunkId] + ".js";
};